import { render } from "./NuevoPacienteModal.vue?vue&type=template&id=3f010c31"
import script from "./NuevoPacienteModal.vue?vue&type=script&lang=js"
export * from "./NuevoPacienteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__